import * as T from "@shared/types";
import { TRACKING_LINKS } from "./constants";

export const getPurchaseOrderLink = (id: string) => {
  return `/orders/${id}`;
};

export const getPurchaseOrderTarget = (purchaseOrder: T.PurchaseOrder, installation: T.Installation) => {
  if (!installation) {
    return;
  }
  if ("shopify" === installation.serviceId) {
    return `//${installation.domain}/admin/orders/${purchaseOrder.targetObjectId}`;
  }
  if ("woocommerce" === installation.serviceId) {
    return `//${installation.domain}/wp-admin/post.php?post=${purchaseOrder.targetObjectId}&action=edit`;
  }
};

export const getConnectionLink = (id?: string, type?: string, installation?: T.Installation) => {
  if (!installation) {
    return `?type=${type}&id=${id}`;
  }
  if ("woocommerce" === installation.serviceId || "shopify" === installation.serviceId) {
    return `/connections?type=${type}&shop=${installation.domain}&id=${id}`;
  }
  return `?type=${type}&id=${id}`;
};

export const getConnectionTargetShopify = (connection: T.Connection, installation: T.Installation, variant?: T.Variant) => {
  if ("purchaseOrderConnection" === connection.type) {
    return `//${installation.domain}/admin/orders/${connection.purchaseOrderId}`;
  } else if ("productConnection" === connection.type) {
    return variant
      ? `//${installation.domain}/admin/products/${variant.productId}/variants/${connection.targetVariantId}`
      : `//${installation.domain}/admin/products`;
  }
};

export const getConnectionTargetWooCommerce = (connection: T.Connection, installation: T.Installation, variant?: T.Variant) => {
  if ("purchaseOrderConnection" === connection.type) {
    return `//${installation.domain}/wp-admin/post.php?post=${connection.purchaseOrderId}&action=edit`;
  } else if ("productConnection" === connection.type) {
    return variant
      ? `//${installation.domain}/wp-admin/post.php?post=${variant.productId}&action=edit`
      : `//${installation.domain}/wp-admin/edit.php?post_type=product`;
  }
};

export const getConnectionTarget = (connection: T.Connection, installation: T.Installation, variant?: T.Variant) => {
  if (!installation) {
    return;
  }
  if ("shopify" === installation.serviceId) {
    return getConnectionTargetShopify(connection, installation, variant);
  }
  if ("woocommerce" === installation.serviceId) {
    return getConnectionTargetWooCommerce(connection, installation, variant);
  }
};

export const getTrackingLink = (fulfillment: T.Fulfillment) => {
  switch (fulfillment.carrier) {
    case "USPS":
      return `${TRACKING_LINKS.USPS}${fulfillment.trackingNumber}`;
    case "USPS STAMPS":
      return `${TRACKING_LINKS["USPS STAMPS"]}${fulfillment.trackingNumber}`;
    case "FedEx":
      return `${TRACKING_LINKS.FedEx}${fulfillment.trackingNumber}`;
    case "UPS":
      return `${TRACKING_LINKS.UPS}${fulfillment.trackingNumber}`;
    case "DHL express":
      return `${TRACKING_LINKS["DHL express"]}${fulfillment.trackingNumber}`;
    default:
      return `${TRACKING_LINKS.DEFAULT}${fulfillment.trackingNumber}`;
  }
};

export const getInvoiceDetailsLink = (invoiceId: string) => {
  return `/invoices/${invoiceId}`;
};
